import { get, post } from '../../../../lib/fetch'
import { getCurrentHost } from '../../../../utils/Utils'

const ERROR_MSG = 'Oops! Something went wrong. Please try again.'

const cardVerificationHandler = async plusCardNumber => {
  try {
    return await get(
      `${getCurrentHost()}/members/card-number/${plusCardNumber}`
    )
  } catch ({ message }) {
    throw new Error(message || ERROR_MSG)
  }
}

const otpVerificationHandler = async (code, id, channel) => {
  try {
    return await post(`${getCurrentHost()}/members/${id}/otp/verify`, {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        channel,
        code,
      }),
    })
  } catch ({ message }) {
    throw new Error(message || ERROR_MSG)
  }
}

const requestOtpHandler = async (id, channel) => {
  try {
    return await post(`${getCurrentHost()}/members/${id}/otp`, {
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ channel }),
    })
  } catch ({ message }) {
    throw new Error(message || ERROR_MSG)
  }
}

const services = {
  requestOtp: (state, send) => {
    requestOtpHandler(
      state.maskedUserDetails.id,
      state.selectedOtpMethod.channel
    )
      .then(() => send({ type: 'OTP_REQUESTED' }))
      .catch(error =>
        send({
          type: 'REQUEST_OTP_ERROR',
          errorMsg: error.name === 'Error' ? error.message : ERROR_MSG,
        })
      )
  },
  authenticated: state => {
    return state.redirectToProfile()
  },
  verifyingOTP: (state, send) => {
    otpVerificationHandler(
      state.otpNumber,
      state.maskedUserDetails.id,
      state.selectedOtpMethod.channel
    )
      .then(result => {
        state.saveCredentials({
          memberId: state.maskedUserDetails.id,
          token: result['x-token'],
        })
      })
      .then(() => send({ type: 'AUTHENTICATED' }))
      .catch(error => {
        send({
          type: 'OTP_VERIFICATION_ERROR',
          errorMsg: error.name === 'Error' ? error.message : ERROR_MSG,
        })
      })
  },
  verifyCardNumber: (state, send) => {
    cardVerificationHandler(state.plusCardNumber)
      .then(maskedUserDetails => {
        const sanitizedMaskedDetails = state.otpMethods.reduce(
          (acc, otpMethod) => {
            return {
              ...acc,
              [otpMethod.key]: acc[otpMethod.key].replace(/X/g, '*'),
            };
          },
          maskedUserDetails
        )

        send({
          type: 'SELECT_OTP_METHOD',
          maskedUserDetails: sanitizedMaskedDetails,
        })
      })
      .catch(error => {
        send({
          type: 'VERIFICATION_ERROR',
          errorMsg: error.name === 'Error' ? error.message : ERROR_MSG,
        })
      })
  },
}

export default services
